import { Component, HostListener, OnInit } from '@angular/core';
import { throttle } from 'lodash';

import { environment } from '../../../environments/environment';
import { Page } from '../../helpers/page';

import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-headlines',
    templateUrl: './headlines.component.html',
    styleUrls: ['./headlines.component.scss']
})
export class HeadlinesComponent implements OnInit {

    activeAnchor: string;
    headlines: Array<HTMLHeadingElement>;
    private throttledInitActive: () => void = throttle(this.initActive, environment.throttleInterface);
    url: string;

    @HostListener('window:resize', [])
    onWindowResize() {
        this.throttledInitActive();
    }

    constructor(
        private docsService: DocsService,
    ) { }

    ngOnInit() {
        this.init();
        this.docsService.getContentChange().subscribe(() => {
            this.init();
        });

        this.docsService.getPageScroll().subscribe(() => {
            this.throttledInitActive();
        });
    }

    private init(): void {
        // let Angular render DOM firstly
        setTimeout(() => {
            this.url = `${location.origin}${location.pathname}`;

            const page: Page = this.docsService.getPage();

            if (page && environment.headlineSelectors.has(page.page_type)) {
                const selector: string = environment.headlineSelectors.get(page.page_type);
                this.headlines = Array.from(window.document.querySelectorAll(selector));
            } else {
                this.headlines = [];
            }

            this.throttledInitActive();
        });
    }

    private initActive(): void {
        if (!this.headlines || !this.headlines.length) {
            return;
        }

        // Calculate 'active' area borders
        const header: HTMLElement = document.querySelector('header');
        const headerRect: ClientRect = header.getBoundingClientRect();
        const areaTop: number = headerRect.bottom;
        const areaBottom: number = areaTop + environment.activeHeadingArea;

        let activeHeadline = null;
        let lastHeadline = null;

        for (const headline of this.headlines) {
            const headlineRect: ClientRect = headline.getBoundingClientRect();

            // Check if heading is inside of 'active' area
            const inside: boolean = (
                areaTop < headlineRect.top && areaBottom > headlineRect.top ||
                areaTop < headlineRect.bottom && areaBottom > headlineRect.bottom
            );

            // Highlight the fist active headline
            if (!activeHeadline && inside) {
                activeHeadline = headline;
            }

            // If no active headline, highlight the previous one
            if (headlineRect.bottom < areaTop) {
                lastHeadline = headline;
            }
        }

        activeHeadline = activeHeadline || lastHeadline || this.headlines[0];
        this.activeAnchor = activeHeadline.dataset.anchor;
    }
}
